/* eslint-disable react/jsx-props-no-spreading */
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import AsyncSelect from 'react-select/async';
import ReactSelect from 'react-select';
import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';

import getSelectComponentStyles from '../helpers/getSelectComponentStyles';

import defaultSelectComponents from './defaultSelectComponents';

const Select = ({
  ariaLabel, components, isAsync, isFluid, size, ...rest
}) => {
  const Element = isAsync ? AsyncSelect : ReactSelect;

  const metaTags = document.querySelectorAll('meta');
  const lastMetaTag = metaTags[metaTags.length - 1];

  const cache = useMemo(
    () => createCache({
      key: 'react-select-custom-styling',
      insertionPoint: lastMetaTag || document.querySelector('title'),
    }),
    [],
  );

  return (
    <CacheProvider value={cache}>
      <Element
        aria-label={ariaLabel}
        components={{ ...defaultSelectComponents, ...components }}
        isFluid={isFluid}
        isSearchable={false}
        size={size}
        styles={getSelectComponentStyles()}
        {...rest}
      />
    </CacheProvider>
  );
};

Select.defaultProps = {
  ariaLabel: '',
  components: {},
  isAsync: false,
  isFluid: false,
  size: 'medium',
};

Select.propTypes = {
  ariaLabel: PropTypes.string,
  components: PropTypes.objectOf(PropTypes.func),
  isAsync: PropTypes.bool,
  isFluid: PropTypes.bool,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
};

export default React.memo(Select);
